import { ElectronicTradingWidgetProps } from '@cian/frontend-electronic-trading-widget';

import { FC, useCallback, useMemo } from 'react';

import { useApplicationContext } from 'shared/context/ApplicationContext';
import { useCardOfferDataContext, useCardOfferPublisherContext } from 'shared/context/CardContext';
import { useCAForCard } from 'shared/hooks/useCAForCard';
import { extractUndefined } from 'shared/utils/extractUndefined';
import { formatPhone } from 'shared/utils/formatPhone';

import { JoinElectronicTradingButton } from './JoinElectronicTradingButton';

type JoinElectronicTradingButtonContainerProps = {
  buttonText: string;
};

export const JoinElectronicTradingButtonContainer: FC<JoinElectronicTradingButtonContainerProps> = props => {
  const { buttonText } = props;
  const { config } = useApplicationContext();
  const { tradingLink } = useCardOfferDataContext();
  const { phones, media, typeLabels, name } = useCardOfferPublisherContext();
  const caForCard = useCAForCard();

  const legalLink = config.getStrict<string>('electronicTrading.legalDocsUrl');

  const trackJoinTrade = useCallback((): void => {
    caForCard({ action: 'Phones_Rosimuschestvo_popup_click', category: 'Listing' });
  }, [caForCard]);

  const trackShowTradingWidgetModal = useCallback((): void => {
    caForCard({ action: 'Open_listing_rosimuschestvo', category: 'Phones' }, { label: true });
  }, [caForCard]);

  /**
   * Эти события трекать не требуется. Добавить, если требования поменяются.
   */
  const trackLegalLinkClick = useCallback((): void => {}, []);
  const trackPublisherPhoneNumberClick = useCallback((): void => {}, []);

  const widgetProps = useMemo((): ElectronicTradingWidgetProps => {
    const prettyPhones = phones.map(formatPhone);
    const publisherTypeLabel = typeLabels?.[0] || '';

    return {
      deviceType: 'desktop',
      joinTradeButtonLink: tradingLink,
      legalLink,
      publisherAvatarSrc: extractUndefined(media.picture),
      publisherName: name,
      publisherPhoneNumbers: prettyPhones,
      publisherTypeLabel,
      trackJoinTrade,
      trackLegalLinkClick,
      trackPublisherPhoneNumberClick,
    };
  }, [
    legalLink,
    media.picture,
    name,
    typeLabels,
    phones,
    trackJoinTrade,
    trackLegalLinkClick,
    trackPublisherPhoneNumberClick,
    tradingLink,
  ]);

  return (
    <JoinElectronicTradingButton
      {...widgetProps}
      buttonText={buttonText}
      trackShowTradingWidgetModal={trackShowTradingWidgetModal}
    />
  );
};
